module.exports = __webpack_public_path__ + "Flag-304.99e45d8f30cfe0b1b486f99b7df185d1.svg";